// @ts-nocheck
/* eslint-disable */
export const appProfile24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.5" cx="12" cy="9" r="4" fill="currentColor"/><path d="M12 12C7.58172 12 4 15.5817 4 20L20 20C20 15.5817 16.4183 12 12 12Z" fill="currentColor"/></svg>`,
    name: 'profile-24' as const
};